import range from 'lodash-es/range';
export function rangeOptions(from: number, to: number) {
    return range(from, to).map(i => {
        return { key: i, title: i + '' };
    });
}
